import BigNumber from "bignumber.js";
import {OptionValue} from "./SharedTypes";

export function formatMoney(x: string | number | undefined | null | BigNumber) {
    if (x === null || x === undefined) {
        return '';
    }
    const number = new BigNumber(x || 0);
    return '$' + (number.isInteger() ? number.toNumber().toLocaleString()
        : number.toNumber().toLocaleString(undefined, {
            'minimumFractionDigits': 0,
            'maximumFractionDigits': 0
        }));
}

export function getPriceDesc(optionValue: OptionValue): string {
    const pricing = optionValue.pricing;
    const priceStr = formatMoney(pricing?.amount);
    return (pricing?.maxQuantity && pricing.maxQuantity > 1)
        ? `${priceStr} ${pricing.unitName ? `per ${pricing.unitName}` : 'each'}` : priceStr;
}

export function getOptionPrice(optionValue: OptionValue, fieldData: Record<string, string>): BigNumber {
    const pricing = optionValue.pricing;
    const priceAmount = new BigNumber(pricing?.amount || 0),
        quantity = parseInt(fieldData.quantity || '1') || 1;
    return priceAmount.times(quantity);
}

/*export function getEncodedImage(url: string) {
    return fetch(url).then(r => r.blob())
        .then(blob => new Promise(resolve => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function () {
                resolve(reader.result);
            }
        }));
}*/

export const inputStyles = {
    '& input': {
        background: "none",
        border: 'none',
        boxShadow: 'none !important',
        paddingLeft: 0
    }
};